export default __webpack_public_path__ + "static/media/cover-default.83be23e1.png";